import React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

interface SectionHeaderProps {
  BackLink?: string | (() => void);
  Breadcrumbs?: string[];
  Children?: JSX.Element;
  Title: string;
}

const SectionHeader = ({
  BackLink = '',
  Breadcrumbs = [],
  Children = null,
  Title,
}: SectionHeaderProps) => {
  const generateKey = pre => {
    return `${pre}_${new Date().getTime()}`;
  };

  const navigate = useNavigate();

  const handleBackClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    if (typeof BackLink === 'function') {
      BackLink();
    } else if (typeof BackLink === 'string') {
      navigate(BackLink);
    }
  };

  return (
    <div className="sectionheader d-flex align-items-start mb-24 mb-lg-32">
      {BackLink && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          to="#"
          className="sectionheader-button-back bg-white btn border rounded-circle me-16 px-8 py-8"
          onClick={handleBackClick}
        >
          <span className="bi bi-arrow-left" />
        </Link>
      )}
      <div className="flex-grow-1">
        {Breadcrumbs && (
          <Breadcrumb className="breadcrumb-sm">
            {Breadcrumbs?.map(item => (
              <Breadcrumb.Item active key={generateKey(item)}>
                {item}
              </Breadcrumb.Item>
            ))}
          </Breadcrumb>
        )}
        <h1 className="h4 m-0 fw-medium">{Title}</h1>
      </div>
      {Children && <div>{Children}</div>}
    </div>
  );
};

// SectionHeader.defaultProps = {
//   BackLink: '',
//   Breadcrumbs: [],
//   Children: null,
// };

export default SectionHeader;
export { SectionHeader };
export type { SectionHeaderProps };
